<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter une période comptable</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier une période comptable</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">
        <div class="col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>Date de fin</mat-label>
            <input matInput [matDatepicker]="picker" name="nth-date" 
              formControlName="date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="form.get('date').errors">
              {{form.get('date').errors['invalidDate']}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Statut</mat-label>
            <input matInput type="text" formControlName="statut">
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Mois</mat-label>
            <input matInput name="mois" formControlName="mois">
            </mat-form-field>  
        </div>
        <div class="col-sm-12">
          <mat-form-field class="full-width">
          <mat-label>Annee</mat-label>
          <input matInput name="annee" formControlName="annee">
          </mat-form-field>
      </div>
    </form>
  </div>
  
  <div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
  </div>

